<template>
  <div id="order-manage">
    <!--搜索-->
    <div class="top">
      <el-col :span="12">
        <el-input placeholder="请输入订单号、用户名、关联代理商" v-model="input" class="input-with-select" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :span="2" :offset="1">
      </el-col>
    </div>
    <!--表格-->
    <div class="order-table">
      <el-table
        border
        :data="tableData">
        <el-table-column 
          label="序号" 
          align="center" 
          width="50">
          <template slot-scope="scope">
            {{ (scope.$index+1)+pageSize*(currentPage-1)}}
          </template>
        </el-table-column>
        <el-table-column
          label="订单号"
          align="center"
          width="200"
          prop="orderId">
        </el-table-column>
        <el-table-column
          label="代理商"
          width="120"
          show-overflow-tooltip
          prop="sellerAccount">
        </el-table-column>
        <el-table-column
          label="购票用户"
          show-overflow-tooltip
          prop="customerNick">
        </el-table-column>
        <el-table-column
          label="状态"
          align="center"
          show-overflow-tooltip
          prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1">出票中</span>
            <span v-if="scope.row.status==2">出票成功</span>
            <span v-if="scope.row.status==3">出票失败</span>
            <span v-if="scope.row.status==4">纠纷中</span>
            <span v-if="scope.row.status==5">订单关闭</span>
            <span v-if="scope.row.status==6">订单异常</span>
          </template>
        </el-table-column>
        <el-table-column
          label="售价"
          align="center"
          prop="totalPrice">
        </el-table-column>
        <el-table-column
          label="代理佣金"
          width="80"
          show-overflow-tooltip
          prop="commission">
        </el-table-column>
        <el-table-column
          label="电影名"
          width="120"
          show-overflow-tooltip
          prop="movieName">
        </el-table-column>
        <el-table-column
          label="影院名"
          width="120"
          show-overflow-tooltip
          align="center"
          prop="cinemaName">
        </el-table-column>
        <el-table-column
          label="城市"
          align="center"
          prop="cityName">
        </el-table-column>
        <!-- <el-table-column
          label="观影时间"
          width="200"
          show-overflow-tooltip
          prop="showTime">
        </el-table-column> -->
        <el-table-column
          label="详情"
          width="200"
          show-overflow-tooltip
          prop="others">
        </el-table-column>
        <el-table-column
          label="下单时间"
          width="200"
          show-overflow-tooltip
          prop="createTime">
        </el-table-column>
        <!-- <el-table-column 
        width="100"
        align="center"
        label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">撤销</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
    import {getCurrentPageBOrder,deleteOrder} from '../../../api/index'
    import {MessageBox,Message} from 'element-ui'
    export default {
        name: "OrderManage",
        data(){
          return{
            tableData:[],
            total:0,
            currentPage:1,
            pageSize: 15,
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'left',
            input:'',
            searchInput:'',
          }
        },
        created() {
          this.loadCurrentPageOrder(this.currentPage,this.pageSize,'');
        },
        methods:{
          async loadCurrentPageOrder(currentPage,pageSize,input){
            const sellerId = this.$cookies.get("sellerId");
            let json = await getCurrentPageBOrder(currentPage,pageSize,input,sellerId);
            if (json.state===200){
              this.tableData = json.data.beanList;
              this.total = json.data.tr;
            }
          },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageOrder(this.currentPage,this.pageSize,this.searchInput);
          },
          //搜索订单
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageOrder(1,this.pageSize,this.searchInput);
          },
          // handleDelete(index, row) {
          //   MessageBox.confirm('此操作将永久删除该订单所有信息, 是否继续？','提示').then(async (value)=>{
          //     if (value==='confirm'){
          //       let json = await deleteOrder(row.id);
          //       if (json.state===200){
          //         Message.success('删除该订单成功！');
          //         this.loadCurrentPageOrder(this.currentPage,this.pageSize,this.searchInput);
          //       }
          //     }
          //   });
          //   console.log(index, row);
          // },
        }
    }
</script>

<style>
  .order-table{
    width:95%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    padding-left: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/children/OrderManage.vue